import { IconDefinition } from "../components/Icon/Icon.generated";
import hover353Image from "../assets/images/Infinite353/353-hover.png";
import hover50x60Image from "../assets/images/Infinite60x50/60x50-hover.png";
import hover110x313Image from "../assets/images/Infinite313x110/313x110-hover.png";

export interface faqType {
  question: string;
  answer: string;
}

export interface productsFaqsType {
  id: string;
  name: string;
  image: IconDefinition;
  hoverImage: any;
  faq: faqType[];
}

export const productsFaqs: productsFaqsType[] = [
  {
    id: "353",
    name: "Infinite",
    image: "353",
    hoverImage: hover353Image,
    faq: [
      {
        question: "Does Infinite 353 support 5G?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
      {
        question: "How to connect Infinite 353 with Cloud?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
      {
        question: "Can you connect Infinite 353 multiple devices?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
    ],
  },
  {
    id: "60",
    name: "Infinite",
    image: "50-60",
    hoverImage: hover50x60Image,
    faq: [
      {
        question: "Does Infinite 60 support 5G?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
      {
        question: "How to connect Infinite 60 with Cloud?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
      {
        question: "Can you connect Infinite 60 multiple devices?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
    ],
  },
  {
    id: "50",
    name: "Infinite",
    image: "50-60",
    hoverImage: hover50x60Image,
    faq: [
      {
        question: "Does Infinite 50 support 5G?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
      {
        question: "How to connect Infinite 50 with Cloud?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
      {
        question: "Can you connect Infinite 50 multiple devices?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
    ],
  },
  {
    id: "313",
    name: "Infinite",
    image: "313-110",
    hoverImage: hover110x313Image,
    faq: [
      {
        question: "Does Infinite 313 support 5G?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
      {
        question: "How to connect Infinite 313 with Cloud?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
      {
        question: "Can you connect Infinite 313 multiple devices?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
    ],
  },
  {
    id: "110",
    name: "Infinite",
    image: "313-110",
    hoverImage: hover110x313Image,
    faq: [
      {
        question: "Does Infinite 110 support 5G?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
      {
        question: "How to connect Infinite 110 with Cloud?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
      {
        question: "Can you connect Infinite 110 multiple devices?",
        answer:
          "Wondering how to switch to a new device? Infinite Phone \n" +
          "Clone makes super-fast transfers come true easily and safely.",
      },
    ],
  },
];
